import Image from 'next/image';
import ImageCTA from './images/CTA-report-img.png';
import Link from 'next/link';

export const ReportCallToAction = () => {
  return (
    <section id="report-cta" className="pb-0">
      <div className="container flex flex-col lg:flex-row">
        <div className="flex xl:w-[660px] lg:basis-1/2 sm:h-[368px] lg:h-[444px] min-h-[280px] relative">
          <Image
            className="object-cover object-center rounded-tl-3xl rounded-tr-3xl rounded-bl-none rounded-br-none lg:rounded-tl-3xl lg:rounded-tr-none lg:rounded-bl-3xl lg:rounded-br-none"
            {...ImageCTA}
          />
        </div>
        <div className="bg-pink rounded-b-3xl px-3 sm:px-[68px] md:px-[128px] lg:px-8 xl:px-[60px] lg:rounded-bl-none lg:rounded-tr-3xl flex flex-col justify-center items-start">
          <h2 className="text-pink-dark mt-10 mb-3">
            Ready to start your Snapi subscription?
          </h2>
          <p className="text-pink-dark">
            Begin regularly monitor your baby's microbiome health with 25% off!
          </p>
          <div className="mt-10 mb-10 z-50 w-full">
            <Link href="https://www.snapihealth.com/#buy-variants">
              <button className="w-full flex justify-center items-center h-[60px] rounded-full uppercase disabled:bg-gray-soft disabled:shadow-none disabled:border-none bg-green hover:bg-green-hover hover:shadow-none focus:bg-green-focus focus:shadow-none md:w-[280px]">
                <h5>To start subscription — $99</h5>
              </button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};
